/* eslint-disable */
import Oidc from "oidc-client";
// import 'babel-core';

const ids = window.SERVERAPI.IDS;
const clientId = window.SERVERAPI.IDS_CLIENT_ID;
const scope = window.SERVERAPI.IDS_SCOPE;
const automaticSilentRenew = window.SERVERAPI.IDS_AUTOSILENTRENEW != undefined ? window.SERVERAPI.IDS_AUTOSILENTRENEW : true;
const checkSessionInterval = window.SERVERAPI.IDS_CHECKSESSIONINTERVAL != undefined ? window.SERVERAPI.IDS_CHECKSESSIONINTERVAL : 2000;
const monitorSession = window.SERVERAPI.IDS_MONITORSESSION != undefined ? window.SERVERAPI.IDS_MONITORSESSION : true;
const REDIRECTORIGIN = window.SERVERAPI.IDS_REDIRECTORIGIN || window.location.origin;

// console.log(`oidc ids:${ids},${clientId},${scope},${automaticSilentRenew},${checkSessionInterval},${monitorSession},${REDIRECTORIGIN}`);

var mgr = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore(),
  authority: ids,
  client_id: clientId,
  redirect_uri: REDIRECTORIGIN + "/oidc/callback.html",
  response_type: "id_token token",
  scope: scope,
  post_logout_redirect_uri: REDIRECTORIGIN,
  silent_redirect_uri: REDIRECTORIGIN + "/oidc/silent-renew.html",
  accessTokenExpiringNotificationTime: 120,
  automaticSilentRenew: automaticSilentRenew,
  filterProtocolClaims: true,
  loadUserInfo: true,
  checkSessionInterval: checkSessionInterval,
  monitorSession: monitorSession
});

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function (user) {
  Oidc.Log.debug("Securityservice.js: New User Loaded:", user, Date.now());
});

mgr.events.addAccessTokenExpiring(function () {
  Oidc.Log.info("Securityservice.js: AccessToken Expiring", Date.now());
});

mgr.events.addAccessTokenExpired(function () {
  Oidc.Log.info("Securityservice.js: AccessToken Expired:", new Date());
  mgr.signinSilent().then(
    user => {
      Oidc.Log.debug(
        "Securityservice.js: addAccessTokenExpired: Silent token renewal successful", user
      );
    },
    err => {
      Oidc.Log.error(
        "Securityservice.js: addAccessTokenExpired: Error from signinSilent:",
        err.message
      );
    }
  );
});

mgr.events.addSilentRenewError(function () {
  Oidc.Log.error("Securityservice.js: Silent Renew Error:", new Date());
  mgr.signinSilent().then(
    user => {
      Oidc.Log.debug(
        "Securityservice.js: SilentRenewService._tokenExpiring: Silent token renewal successful"
      );
    },
    err => {
      Oidc.Log.error(
        "Securityservice.js: SilentRenewService._tokenExpiring: Error from signinSilent:",
        err.message
      );
    }
  );
});

mgr.events.addUserSignedOut(function () {
  Oidc.Log.warn("Securityservice.js: SessionMonitor UserSignedOut:", new Date());
  mgr
    .signoutRedirect()
    .then(function (resp) {
      console.log("signed out", resp);
    })
    .catch(function (err) {
      console.log(err);
    });
});

export default class SecurityService {
  // Renew the token manually
  renewToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .signinSilent()
        .then(function (user) {
          if (user == null) {
            self.signIn(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user who is logged in
  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Check if there is any user logged in
  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Redirect of the current window to the authorization endpoint.
  signIn() {
    mgr.signinRedirect().catch(function (err) {
      console.log(err);
    });
  }

  // Redirect of the current window to the end session endpoint
  signOut() {
    mgr
      .signoutRedirect()
      .then(function (resp) {
        console.log("signed out", resp);
        return mgr.clearStaleState();
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  // Get the profile of the user logged in
  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the token id
  getIdToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.id_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the session state
  getSessionState() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.session_state);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the access token of the logged in user
  getAcessToken() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.access_token);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Takes the scopes of the logged in user
  getScopes() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.scopes);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  // Get the user roles logged in
  getRole() {
    let self = this;
    return new Promise((resolve, reject) => {
      mgr
        .getUser()
        .then(function (user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile.role);
          }
        })
        .catch(function (err) {
          console.log(err);
          return reject(err);
        });
    });
  }
}
